import axios from 'axios'
import  { getTokenInCookie } from './index'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

let testburl = process.env.NODE_ENV == 'production' ? 'https://javaop.univ-bio.com/' : 'https://javaopt.univ-bio.com'//java测试
// const testburl = 'http://192.168.0.222:8181/'//李成飞
// create an axios instance
const https = axios.create({
  baseURL: testburl,
  timeout: 120 * 1000 // request timeout
})

// request interceptor
https.interceptors.request.use(
  config => {
      var token = getTokenInCookie();
      if (!!token) {
      config.headers['X-Token'] = getTokenInCookie()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

https.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 3 * 1000
    // })
    return Promise.reject(error)
  }
)

export default https



// WEBPACK FOOTER //
// ./src/utils/httpjavaRequest.js